<template>
    <div class="d-flex flex-column justify-content-center align-items-center">
        <img src="../assets/infinite-logo-blue.svg" class="p-2 m-2" style="height: 80px;" />
        <h3 v-if="loggedOut">You have been logged out</h3>
        <h4 v-if="loggedOut"><router-link to="/">Log In</router-link></h4>
        <h3 v-if="!loggedOut">
            <span class="fa fa-spinner fa-spin"></span>
            Logging out...
        </h3>
    </div>
</template>

<script>
import GoogleAuth from './GoogleAuth'
import auth from '../auth'

export default {
    data() {
        return {
            loggedOut: false
        }
    },
    async created() {
        auth.logout();

        if(GoogleAuth.isGsuiteUser()) {
            this.loggedOut = true;
        }
        else {
            this.$router.push('/');
        }
    },
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/framework/Logout.vue